// extracted by mini-css-extract-plugin
export default {"cls1":"Tooltip-cls1_OAF","cls2":"Tooltip-cls2_ch_ Tooltip-cls1_OAF"};